import { createFileRoute } from '@tanstack/react-router';
import { AuthLayout } from '@/features/auth/components/auth-layout/AuthLayout';
import { ResetPasswordPage } from '@/features/auth/pages/reset-password-page/ResetPasswordPage';

const RouteComponent = () => {
  const { token } = Route.useParams();
  return (
    <AuthLayout>
      <ResetPasswordPage token={token} />
    </AuthLayout>
  );
};

export const Route = createFileRoute('/reset-password/$token')({
  component: RouteComponent,
});
